const ERole = Object.freeze({
    ROLE_ADMIN: "ROLE_ADMIN",
    ROLE_USER: "ROLE_USER",

    ROLE_ACC: "ROLE_ACC",
    ROLE_SALES_ADM: "ROLE_SALES_ADM",
    ROLE_PURCHASE: "ROLE_PURCHASE",
    ROLE_FINANCE: "ROLE_FINANCE",
    ROLE_MANAGER: "ROLE_MANAGER",
    ROLE_OWNER: "ROLE_OWNER",
    ROLE_SALESMAN: "ROLE_SALESMAN",
    ROLE_INVENTORY: "ROLE_INVENTORY",
    ROLE_SPV: "ROLE_SPV",

    ROLE_AGEN: "ROLE_AGEN",
    ROLE_RSL_1: "ROLE_RSL_1",
    ROLE_RSL_2: "ROLE_RSL_2",
    ROLE_CS: "ROLE_CS",

})
const ERoleValues = [
    ERole.ROLE_ADMIN,
    ERole.ROLE_USER,

    ERole.ROLE_ACC,
    ERole.ROLE_SALES_ADM,
    ERole.ROLE_PURCHASE,
    ERole.ROLE_FINANCE,
    ERole.ROLE_MANAGER,
    ERole.ROLE_OWNER,
    ERole.ROLE_SALESMAN,
    ERole.ROLE_INVENTORY,
    ERole.ROLE_SPV,

    ERole.ROLE_AGEN,
    ERole.ROLE_RSL_1,
    ERole.ROLE_RSL_2,
    ERole.ROLE_CS,

]

// Keep retired role constants for the data restrictions of existing accounts.
const ERetiredRoleValues = Object.freeze([ERole.ROLE_AGEN, ERole.ROLE_RSL_1, ERole.ROLE_RSL_2])
const EAssignableRoleValues = Object.freeze(ERoleValues.filter(role => !ERetiredRoleValues.includes(role)))

function isOwner(user) {
    return !!user?.roles?.includes(ERole.ROLE_OWNER)
}

function canManageOwner(user) {
    return user?.organizationLevel === 'SYS' && !!user?.roles?.includes(ERole.ROLE_ADMIN)
}

function roleTitle(role) {
    return role === ERole.ROLE_OWNER ? 'ROLE_OWNER (Owner / Pimpinan Holding)' : role
}

function userRoleOptions(user, existingRoles = []) {
    const active = EAssignableRoleValues.filter(role => role !== ERole.ROLE_OWNER || canManageOwner(user) || existingRoles.includes(role))
    return [...active, ...ERetiredRoleValues.filter(role => existingRoles.includes(role))].map(role => ({
        value: role,
        title: roleTitle(role),
        props: { disabled: ERetiredRoleValues.includes(role) || (role === ERole.ROLE_OWNER && !canManageOwner(user)) },
    }))
}

function userRoleError(roles, user, existingRoles = [], level = "", existingLevel = "") {
    if (!Array.isArray(roles) || !roles.length) return 'Pilih minimal satu role.'
    if (roles.some(role => ERetiredRoleValues.includes(role) && !existingRoles.includes(role))) return 'Role AGEN/RSL tidak tersedia untuk penugasan baru.'
    if ((roles.includes(ERole.ROLE_ADMIN) && level.toUpperCase() === "SYS") ||
        (existingRoles.includes(ERole.ROLE_ADMIN) && existingLevel.toUpperCase() === "SYS")) {
        if (!canManageOwner(user)) return "Hanya Admin Holding (SYS) yang dapat mengelola akun Admin Holding."
    }
    if (roles.includes(ERole.ROLE_OWNER) || existingRoles.includes(ERole.ROLE_OWNER)) {
        if (!canManageOwner(user)) return 'Hanya Admin Holding (SYS) yang dapat mengelola user Owner.'
        if (roles.includes(ERole.ROLE_OWNER) && roles.length !== 1) return 'ROLE_OWNER harus dipilih sendiri.'
    }
    return true
}

export { ERole as default, ERoleValues, ERetiredRoleValues, EAssignableRoleValues, isOwner, canManageOwner, roleTitle, userRoleOptions, userRoleError }
